"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function Badge({ count, style, transparent }) {
    const size = 20;
    return ((0, jsx_runtime_1.jsx)("div", { style: style, children: (0, jsx_runtime_1.jsx)("div", { style: {
                backgroundColor: transparent ? "" : "white",
                borderRadius: size,
                // padding: 5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: size,
                height: size,
            }, children: (0, jsx_runtime_1.jsx)("strong", { children: count }) }) }));
}
exports.Badge = Badge;
